var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaybackSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.5,
    height: 21.5,
    viewBox: "0 0 21.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "playback-speed-svgrepo-com",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M9.607,1.517a10.75,10.75,0,1,1,0,20.965A.75.75,0,1,1,9.94,21.02a9.25,9.25,0,1,0,0-18.04.75.75,0,1,1-.333-1.463Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1038",
    "data-name": "Group 1038",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M7.313,3.132a.75.75,0,0,1-.235,1.034A9.3,9.3,0,0,0,4.166,7.078a.75.75,0,0,1-1.269-.8A10.8,10.8,0,0,1,6.279,2.9.75.75,0,0,1,7.313,3.132Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M3.132,16.686a.75.75,0,0,1,1.034.235,9.3,9.3,0,0,0,2.912,2.912.75.75,0,1,1-.8,1.269A10.8,10.8,0,0,1,2.9,17.72.75.75,0,0,1,3.132,16.686Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M2.98,9.94a.75.75,0,1,0-1.463-.333,10.838,10.838,0,0,0,0,4.785A.75.75,0,1,0,2.98,14.06a9.338,9.338,0,0,1,0-4.12Z",
    fill: "#fff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M15.414,10.941a1.25,1.25,0,0,1,0,2.118l-4.72,2.787A1.142,1.142,0,0,1,9,14.787V9.213a1.142,1.142,0,0,1,1.693-1.059Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaybackSpeed);
export default __webpack_public_path__ + "static/media/playback-speed.83f14d1d4b7f6dfad2fc903bec466016.svg";
export { ForwardRef as ReactComponent };